<template>
    <!-- display buttons for unsave for later here -->
    <button @click.prevent="unsaveItemFxn(itemId)">
        <i class="fas fa-save"></i> Unsave Item
    </button>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: 'UnsaveForLater',
    props: {
        itemId: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            itemSavedStatus: false,
        }
    },
    methods: {
        ...mapActions(['fetchSavedLaterItemsAction']),
        unsaveItemFxn(theItemId) {
            // check if user already has a save-for-later items on local-storage
            let localStorageSFLItemIds = JSON.parse(localStorage.getItem('ani_items_sfl')) 
            if(localStorageSFLItemIds) {
                // filter out the unwanted itemId and re-store the balance
                let updatedItemsIdArr = localStorageSFLItemIds.filter(itemId => itemId !== theItemId)

                // refetch the saved items using the updated items id array aka refresh SavedForLater page
                let savedLaterObj = {
                    items: updatedItemsIdArr
                }
                this.fetchSavedLaterItemsAction(savedLaterObj).then(() => {}).catch((e) => {})

                // store the update items array as string back in the local storage
                localStorage.setItem('ani_items_sfl', JSON.stringify(updatedItemsIdArr))
            } 
            
            // check and update items saved status
            this.itemSavedChecker(theItemId)
        },
        itemSavedChecker(theItemId) {
            this.$emit('emitItemSavedChecker', theItemId)
        }
    },
}
</script>
